import { useQuery, gql } from '@apollo/client';

const CAN_CREATE_LOGINS = gql`
  query CanCreateLogins {
    canCreateLogins
  }
`;

/**
 * Who gets "Add a teacher", and the "Give login" button on a profile.
 *
 * **The server's own answer**, the same construction as `useCanCreatePerson` and
 * `useCanAccessLeadership` and for the same reason: which roles carry `CREATE_LOGIN` is
 * per-organisation data edited on `/admin/roles`, so a role test copied to this side goes stale
 * silently — either hiding a page the server would serve or offering one it refuses.
 *
 * A top-level query rather than a field on `Membership`, because the question is "may I do this
 * here" and not "what is true of this membership row" — and `Membership`'s fields answer for the
 * *working* organisation regardless of which membership they are resolved on, which is the trap
 * `membershipFieldScope.test.ts` exists to catch.
 */
export const useCanCreateLogins = (): boolean => {
  const { data, loading, error } = useQuery(CAN_CREATE_LOGINS);

  return !loading && !error && !!data?.canCreateLogins;
};
